import { has_feature, WINNERS_V2 } from '@/helpers/features'

/**
 * Espelha o perm_mixin: `can(resource, action)` para permissões,
 * `hasFeature(key)` para recursos contratados.
 *
 * Síncrono de propósito. O cache é preenchido pelo router guard antes da
 * navegação, então isto pode ser usado em `data()`, em `methods` e no
 * breadcrumb — nenhum deles consegue esperar uma promise.
 */
export const feature_mixin = {
    methods: {
        hasFeature(key) {
            return has_feature(key)
        },

        /**
         * Rota de vencedores da conta. Sem o recurso liberado — ou antes do
         * cache existir — devolve o fluxo antigo, que todo cliente enxerga.
         */
        winners_route() {
            return this.hasFeature(WINNERS_V2)
                ? 'cliente-monitores-vencedores-v2'
                : 'cliente-monitores-vencedores'
        },

        /**
         * Link de um item de menu com versão nova: `{ link, v2: { feature, link } }`.
         * Sem o recurso (ou antes do cache existir) fica o link antigo.
         */
        feature_link(item) {
            return item.v2 && this.hasFeature(item.v2.feature) ? item.v2.link : item.link
        },

    },
}
